<template>
  <!--  只允许一个 组件 -->
  <a-layout class="center-container">

    <!--中间布局 background: '#fff', -->
    <a-layout-content class="center-div"
      :style="{ background: '#fff', padding: '75px 50px 20px 50px', margin: 0, minHeight: '720px' }">

      <!-- 内容详情卡片包裹 -->
      <div>

        <!-- 文档位置: 面包屑 -->
        <a-row :gutter="24">
          <a-breadcrumb separator=">" style="margin:0px 0px 20px 10px;">
            <a-breadcrumb-item>
              <router-link :to="'/'">
                首页
              </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>
              <router-link :to="{ path: '/track' }">
                学习路径
              </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>
              路线详情
            </a-breadcrumb-item>
            <a-breadcrumb-item>{{ track.name }}</a-breadcrumb-item>
          </a-breadcrumb>
        </a-row>

        <!-- 标题内容 -->
        <a-typography-title :level="4">{{ track.name }}</a-typography-title>
        <a-typography-paragraph>
          <a-typography-text>{{ track.description }}</a-typography-text>
        </a-typography-paragraph>

        <a-divider />

        <!-- 提示 -->
        <a-row>
          <p>
            <span style="font-size: 18px;color: black;font-weight: 700;"> 路线详情：</span>
            <span> {{ track.stepCount }} 步骤 · {{ track.ebookCount }} 门课</span>
          </p>
        </a-row>

        <!-- 暂无数据 -->
        <template v-if="track.steps == undefined || track.steps.length == 0">
          <a-empty :image="simpleImage" />
        </template>

        <!-- 时间轴线 -->
        <a-timeline v-else style="margin-top: 10px;">

          <a-timeline-item v-for="stepObj in track.steps" :key="stepObj.id">

            <!-- 节点图标 -->
            <template #dot>
              <!-- <TagsOutlined style="font-size: 24px;font-weight: 700;" /> -->
               <!-- 使用阿里巴巴自定义图标 -->
              <icon-font type="icon-buzhou" style="font-size: 20px;font-weight: 700;"></icon-font>
            </template>

            <!-- 文档标题 & 描述 -->
            <a-typography-title :level="5">{{ stepObj.name }}</a-typography-title>
            <a-typography-paragraph>
              <a-typography-text>
                {{ stepObj.description }}
              </a-typography-text>
            </a-typography-paragraph>

            <!-- 展示图书列表 -->
            <the-ebooks-card :data="stepObj.ebooks"></the-ebooks-card>
          </a-timeline-item>

        </a-timeline>

        <!-- 点赞 -->
        <div class="vote-div">
          <a-button type="primary" shape="round" :size="'large'" @click="vote">
            <template #icon>
              <LikeOutlined /> &nbsp;点赞：{{ track.voteCount }}
            </template>
          </a-button>
        </div>

      </div>

    </a-layout-content>

    <!-- 返回页面顶部的操作按钮。 -->
    <a-back-top type="default" />

    <!-- 底部 -->
    <TheFooter></TheFooter>

  </a-layout>

</template>

<script lang="ts">
import { defineComponent, onMounted, ref, reactive, toRef, h } from 'vue';
// 引入axios 库
import axios from "axios";
import { message } from "ant-design-vue";
import { Tool } from "@/util/tool";
import { useRoute } from "vue-router";
// import useRouter from '@/router'
// 引入图标
// import { TagFilled, PushpinOutlined, BranchesOutlined, UserOutlined, SolutionOutlined, LoadingOutlined, SmileOutlined, } from '@ant-design/icons-vue';
import { Empty } from 'ant-design-vue';
import TheEbooksCard from '@/components/the-ebooks-card.vue';
import TheFooter from "@/components/the-footer.vue";


export default defineComponent({
  name: 'Step',
  components: {
    TheEbooksCard,
    TheFooter
  },
  setup() {
    console.log('setup ...')

    // 获取url参数 http://localhost:9999/step?trackId=3
    const route = useRoute();
    const trackId = route.query.trackId;
    console.log('trackId', trackId)

    // 路径详情
    const track: any = ref({});

    const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;

    /**
     * 查询分类的电子书列表
     */
    const handleQuery = () => {

      axios.get("/track/detail/" + trackId).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          //ref
          track.value = result.data
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 点赞
     */
    const vote = () => {
      // 必须有值才可点赞
      if (track.value == undefined || track.value.id == undefined) {
        message.warning('暂无相关数据');
        return
      }
      axios.get('/track/vote/' + track.value.id).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          track.value.voteCount++;
          //提示
          message.success("点赞成功");
        } else {
          message.warning(result.message);
        }
      });
    };

    onMounted(() => {
      console.log('onMounted ...')

      handleQuery()

    })
    return {
      h,
      simpleImage,
      track,
      vote,
    }


  }
});
</script>

<style scoped>
/*电子书图标形状*/
.ant-avatar {
  width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 8%;
  margin: 5px 0;
}

/* 限定描述 2行 */
.description {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
